// extracted by mini-css-extract-plugin
export default {"footer":"AdminFooter_footer__rYODk","footer-content":"AdminFooter_footer-content__m2wCx","footer-text":"AdminFooter_footer-text__bFzdn"};